<template>
  <div class="listPro" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <ul>
      <li v-for="(item,i) in pro" @click="toPush(item.id,'listDetail')">
        <img class="left" :src="baseUrl+item.img[0]" />
        <div class="right">
          <h3>{{item.title}}</h3>
          <div class="business">
            销量：{{item.num}}件
          </div>
          <div class="price">
            <i><b>¥</b> {{item.rate.split(".")[0]}}.<b>{{item.rate.split(".")[1]}}</b></i>
            <span>￥{{item.price}}</span>
          </div>
        </div>
        <a>立即购买</a>
      </li>
    </ul>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        page:1,
        pro:[]
      };
    },
    beforeMount() {
      this.baseUrl = this.$host;
    },
    mounted() {
      this.beforeMount();
      this.getList()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },
      toPush:function(index,url){
        this.$router.push({
          path:url,
          query:{
            id:index
          }
        })
      },

      getList:function(){
        var that = this;
        var b_id = this.$route.query.id;
        that.fullscreenLoading = true
        this.axios({
          method:'post',
          url:that.$host+'home/product/product',
          params:{
            b_id:b_id,
            page:that.page
          }
        }).then(function(response){
          var res = response.data;
          that.pro = res.data;
          that.fullscreenLoading = false
        }).catch(err=>{
          console.log('请求失败:'+err);
          that.fullscreenLoading = false
        });
      },
    }
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .listPro{
    max-width:640px;
    background:#f7faff;
    padding-bottom:5px;
    padding-top:15px;
  }
  .listPro ul{
    width:94%;
    margin:0 auto;
  }
  .listPro li{
    background:#fff;
    box-shadow: 0px 0px 10px 0px rgba(47, 120, 255, 0.2);
    border-radius:8px;
    width:100%;
    padding:13px 0;
    position:relative;
    margin-bottom:15px;
    position:relative;
  }
  .listPro li:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .listPro li .left{
    float:left;
    width:30%;
    border-radius:6px;
    margin-left:3%
  }
  .listPro li .right{
    float:left;
    width:65%;
    margin-left:2%;
  }
  .listPro li .right h3{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    letter-spacing:1px;
    color:#333;
  }
  .listPro li .right .business{
    font-size: 15px;
    color: #999999;
    padding:15px 0
  }


  .listPro ul li .price{
    font-size: 15px;
    font-family: PingFang SC;
    color: #333333;
  }
  .listPro ul li .price i{
    color: #FF6600;
    font-style:normal;
    font-size:16px;
    font-weight:bold;
    padding:0 4px;
  }
  .listPro ul li .price b{
    font-size:12px;
  }
  .listPro ul li .price span{
    text-decoration: line-through;
    color:#999;
    font-size:14px;
    padding-left:10px;
  }

  .listPro ul li a{
    position:absolute;
    right:10px;
    bottom:0px;
    transform: translateY(-50%);
    color:#2F78FF;
    border: 1px solid #2F78FF;
    border-radius: 30px;
    width: 83px;
    height: 30px;
    text-align:center;
    line-height:30px;
    font-weight: 600;
    font-size:14px;
  }
</style>